import { render, staticRenderFns } from "./goodsAddress.vue?vue&type=template&id=75ccd8c6&scoped=true&"
import script from "./goodsAddress.vue?vue&type=script&lang=js&"
export * from "./goodsAddress.vue?vue&type=script&lang=js&"
import style0 from "./goodsAddress.vue?vue&type=style&index=0&id=75ccd8c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ccd8c6",
  null
  
)

export default component.exports